import { render, staticRenderFns } from "./ChildrenRiderWidget.vue?vue&type=template&id=0ba2063e&scoped=true"
import script from "./ChildrenRiderWidget.vue?vue&type=script&lang=js"
export * from "./ChildrenRiderWidget.vue?vue&type=script&lang=js"
import style0 from "./ChildrenRiderWidget.vue?vue&type=style&index=0&id=0ba2063e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba2063e",
  null
  
)

export default component.exports